import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './styles/math.css';
import { useStore } from './stores';

// 初始化认证状态
useStore.getState().initializeAuth();

// 创建根元素并渲染应用
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);